const state = {
	langList: []
}
const getters = {
	getLangList() {
		return state.langList
	}
}
const mutations = {
	setLangList(state, langList) {
		state.langList = langList
	}
}

const actions = {
	setLangList({ commit }, langList) {
		commit('setLangList', langList)
	}
}

//调用方法
//getters调用： this.$store.getters['product/getProduct']
//actions调用： that.$store.dispatch('product/setProduct', pres.data)
//mutations调用： that.$store.commit('product/setProduct', pres.data)

export default{
	namespaced:true,
	state,
	getters,
	mutations,
	actions
}